import React from "react";
import "./product-statics.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { formatDate } from "../../../../../../helpers";

interface ProductStaticsComponentProps {
  loading: boolean;
  product: any;
}

const ProductStaticsComponent = ({
  loading,
  product,
}: ProductStaticsComponentProps) => {
  const { t } = useTranslation();

  return (
    <Box className="global__box__content product__statics mt-4">
      <Box className="product__statics_item">
        <Box className="m-auto">
          {loading ? (
            <Skeleton variant="text" height={20} width={80} />
          ) : (
            <Typography variant="h2">{product.version}</Typography>
          )}
          {loading ? (
            <Skeleton variant="text" height={20} width={100} />
          ) : (
            <Typography
              variant="body1"
              color="textSecondary"
              className="text-capitalize"
            >
              {t("PRODUCTS_PAGE.PRODUCT_VERSION")}
            </Typography>
          )}
        </Box>
      </Box>
      <Box className="product__statics_item">
        <Box className="m-auto">
          {loading ? (
            <Skeleton variant="text" height={20} width={80} />
          ) : (
            <Typography variant="h2">{product.useCases.length}</Typography>
          )}
          {loading ? (
            <Skeleton variant="text" height={20} width={100} />
          ) : (
            <Typography
              variant="body1"
              color="textSecondary"
              className="text-capitalize"
            >
              {t("PRODUCTS_PAGE.RELATED_USE_CASES")}
            </Typography>
          )}
        </Box>
      </Box>
      <Box className="product__statics_item">
        <Box className="m-auto">
          {loading ? (
            <Skeleton variant="text" height={20} width={80} />
          ) : (
            <Typography variant="h2">{product?.files?.length}</Typography>
          )}
          {loading ? (
            <Skeleton variant="text" height={20} width={100} />
          ) : (
            <Typography
              variant="body1"
              color="textSecondary"
              className="text-capitalize"
            >
              {t("PRODUCTS_PAGE.DOCUMENTS")}
            </Typography>
          )}
        </Box>
      </Box>
      <Box className="product__statics_item">
        <Box className="m-auto">
          {loading ? (
            <Skeleton variant="text" height={20} width={80} />
          ) : (
            <Typography variant="h2">{product.licenseType}</Typography>
          )}
          {loading ? (
            <Skeleton variant="text" height={20} width={100} />
          ) : (
            <Typography
              variant="body1"
              color="textSecondary"
              className="text-capitalize"
            >
              {t("PRODUCTS_PAGE.LICENSE_TYPE")}
            </Typography>
          )}
        </Box>
      </Box>
      <Box className="product__statics_item">
        <Box className="m-auto">
          {loading ? (
            <Skeleton variant="text" height={20} width={80} />
          ) : (
            <Typography variant="h2">
              {formatDate(product.licenseValidity, "DD.MM.YYYY")}
            </Typography>
          )}
          {loading ? (
            <Skeleton variant="text" height={20} width={100} />
          ) : (
            <Typography
              variant="body1"
              color="textSecondary"
              className="text-capitalize"
            >
              {t("PRODUCTS_PAGE.LICENSE_VALIDITY")}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ProductStaticsComponent;
